import React from 'react'
// import EngineeringTechnology from './EngineeringTechnology/EngineeringTechnology'
import EquipmentCarbon from './EquipmentCarbon/EquipmentCarbon'
import EquipmentThermoplastics from './EquipmentThermoplastics/EquipmentThermoplastics'
import EquipmentMetalworking from './EquipmentMetalworking/EquipmentMetalworking'
import EquipmentStone from './EquipmentStone/EquipmentStone'
// import NewsPreview from '../../Modules/NewsBlock/NewsPreview'
import HeaderEngineering from '../../Modules/HeaderEngineering/HeaderEngineering'

const EquipmentPage = () => {
  return (
    <div>
      <HeaderEngineering />
      {/*<EngineeringTechnology />*/}
      <EquipmentCarbon />
      <EquipmentThermoplastics />
      <EquipmentMetalworking />
      <EquipmentStone />
      {/*<NewsPreview />*/}
    </div>
  )
}

export default EquipmentPage
